import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useWebSocket from "../../hooks/useWebSocket";
import { API_URL } from "../../network/index"; 

const Maintenance = () => {
  const navigate = useNavigate();

// Dynamically derive WebSocket URL from API_BASE_URL
const wsProtocol = API_URL.startsWith("https") ? "wss" : "ws";
const wsHost = new URL(API_URL).host;
const wsUrl = `${wsProtocol}://${wsHost}/ws`;

  let kiosk = localStorage.getItem("Kiosk")?.replace(/"/g, "").trim(); // Remove quotes & trim whitespace
  const { kioskMaintenanceStatus, isGlobalMaintenance } = useWebSocket(wsUrl);

  //const { kioskMaintenanceStatus, isGlobalMaintenance } = useWebSocket("https://localhost:44375/ws");

  const isKioskUnderMaintenance = kiosk ? kioskMaintenanceStatus[kiosk] ?? false : false; // Avoid undefined issues

  useEffect(() => {
    //console.log("Stored Kiosk ID:", kiosk);
    //console.log("Current kioskMaintenanceStatus:", kioskMaintenanceStatus);
    //console.log("Global Maintenance Status:", isGlobalMaintenance);
    //console.log("Is Kiosk Under Maintenance:", isKioskUnderMaintenance);

    // If Global Maintenance is active, stay on the page
    if (isGlobalMaintenance) {
      console.log("🔴 Global Maintenance Active - Staying on Maintenance Page.");
      localStorage.setItem("isMaintenance", "true");
      return;
    }

    // If no kiosk is found, clear storage and go to login
    if (!kiosk) {
      //console.warn("⚠️ No Kiosk ID found in local storage. Redirecting to login...");
      localStorage.clear();
      sessionStorage.clear();
      //navigate("/");
      window.location.href = "/";

      return;
    }

    // If kiosk is NOT under maintenance, go to login
    if (!isKioskUnderMaintenance) {
      //console.log("✅ Kiosk is active. Redirecting to login...");
      localStorage.clear();
      sessionStorage.clear();
      //navigate("/");
      window.location.href = "/";

    }
  }, [isGlobalMaintenance, isKioskUnderMaintenance, kiosk, navigate]);

  return (
    <div>
      <section className="section-bg3">
        <div>
          <div>
            {/* <img id="staticImage" alt="Maintenance Mode" /> */}
          </div>
        </div>
      </section>
     
    </div>
  );
};

export default Maintenance;